import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { IntegrationConnection } from '@loader/shared-types';

import { useRpc } from '@/lib/rpc';
import { throwApiError } from '@/lib/rpc';
import { queryKeys } from '@/lib/queryKeys';

export function useIntegrationConnectionsQuery() {
  const rpc = useRpc();
  return useQuery({
    queryKey: queryKeys.connectors.integrationConnections,
    queryFn: async (): Promise<IntegrationConnection[]> => {
      const res = await rpc.api.private.connectors.connections.$get();
      if (!res.ok) await throwApiError(res, 'Failed to fetch integration connections');
      const json = (await res.json()) as { connections: IntegrationConnection[] };
      return json.connections;
    },
    staleTime: 30_000,
  });
}

export function useDisconnectIntegrationConnection() {
  const rpc = useRpc();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (connectionId: string) => {
      // @ts-expect-error - Hono RPC type inference limitation for nested routes
      const res = await rpc.api.private.connectors.connections[':id'].$delete({
        param: { id: connectionId },
      });
      if (!res.ok) await throwApiError(res, 'Failed to disconnect integration');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.connectors.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.tables.all });
    },
  });
}
